import { Box, Fade, Tooltip, Typography } from '@mui/material'
import theme from 'lib/theme'
import React, { useEffect, useRef, useState } from 'react'

export const NameColumn = ({
  productName,
  maxWidth,
}: {
  productName: string
  maxWidth?: string
}) => {
  const productNamesRef = useRef<HTMLParagraphElement | null>(null)
  // hover true if there is an ellipsis
  const [hoverStatus, setHoverStatus] = useState(false)

  // checks whether the text overflows and there is an ellipsis
  const checkTextOverflow = () => {
    let compare = false
    if (productNamesRef !== null && productNamesRef.current !== null) {
      compare = Boolean(
        productNamesRef.current &&
          productNamesRef.current.scrollWidth >
            productNamesRef.current.clientWidth
      )
    }
    setHoverStatus(compare)
  }

  useEffect(() => {
    checkTextOverflow()
    window.addEventListener('resize', checkTextOverflow)
    return () => {
      window.removeEventListener('resize', checkTextOverflow)
    }
  }, [])

  return (
    <div
      style={{
        height: '56px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: theme.spacing(1),
      }}>
      <Box
        sx={{
          maxWidth: maxWidth || '180px',
          whiteSpace: 'nowrap',
        }}>
        <Tooltip
          TransitionComponent={Fade}
          disableHoverListener={!hoverStatus}
          title={
            <Typography
              variant='body1'
              sx={{
                margin: theme.spacing(0.5),
                color: theme.palette.text.primary,
              }}>
              {productName}
            </Typography>
          }
          componentsProps={{
            tooltip: {
              sx: {
                height: '80px',
                maxWidth: '200px',
                backgroundColor: theme.palette.commonColors.white,
                color: theme.palette.text.primary,
                boxShadow: 2,
                overflowX: 'scroll',
              },
            },
          }}>
          <Typography
            variant='body1'
            ref={productNamesRef}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              '&:hover': { cursor: hoverStatus ? 'pointer' : 'auto' },
            }}>
            {productName}
          </Typography>
        </Tooltip>
      </Box>
    </div>
  )
}
